"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_SIZES = exports.DEFAULT_PAGE_SIZE = void 0;
exports.DEFAULT_PAGE_SIZE = 10;
exports.PAGE_SIZES = [exports.DEFAULT_PAGE_SIZE, 25, 50, 100, 500];
